import { render } from "./pinch_zoom.vue?vue&type=template&id=4608b5bf"
import script from "./pinch_zoom.js?vue&type=script&lang=js"
export * from "./pinch_zoom.js?vue&type=script&lang=js"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__